<template>
  <el-card class="card-main">
    <el-form ref="searchInfo" :model="searchForm" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="searchForm.projectId" placeholder="请选择所属项目" filterable clearable>
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.teamId" placeholder="请选择班组" filterable clearable>
          <el-option v-for="(item, index) of teamList" :key="index" :label="item.teamName"
            :value="item.teamId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-button class="mb20" @click='addWorker' type="primary" icon='el-icon-plus'>新增</el-button>
    <el-table class="global-table" stripe :data="tableData" v-loading="loading">
      <el-table-column prop="projectName" label="所属项目"></el-table-column>
      <el-table-column prop="teamName" label="班组名称"></el-table-column>
      <el-table-column prop="startDate" label="包工开始日期"></el-table-column>
      <el-table-column prop="endDate" label="包工结束日期"></el-table-column>
      <el-table-column prop="contractAmount" label="包工总额（元）"></el-table-column>
      <el-table-column prop="" label="状态">
        <template v-slot="{ row }">
          {{ row.status === 0 ? '启用' : '禁用' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="240px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="$router.push(`/laborcontract/details?teamLaborId=${row.teamLaborId}`)">查看</el-button>
          <el-button type="text" @click="enableStatus(row.teamLaborId)">{{ row.status === 0 ? '禁用' : '启用' }}</el-button>
          <el-button type="text" @click="$router.push(`/laborcontract/edit?teamLaborId=${row.teamLaborId}`)">编辑</el-button>
          <el-button type="text" @click="deleteConfirm(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="getList"
      @size-change="getList"></GlobalPagination>
  </el-card>
</template>

<script>
// @KeepAlive
export default {
  name: 'projectWorkerList',
  data() {
    return {
      teamList: [],
      searchForm: {
        projectId: '',
        teamId: ''
      },
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      size: 10
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },

  created() {
    this.getList()
    this.loadTeamList()
  },
  methods: {
    enableStatus(teamLaborId) {
      this.$axios.post(this.$apis.laborManage.updateTeamLaborStatus, {
        teamLaborId
      }).then(res => {
        this.getList()
      })
    },
    loadTeamList() {
      this.$axios.get(this.$apis.laborManage.selectYhTeamByList).then(res => {
        this.teamList = res || []
      })
    },
    // 搜索
    onSearch() {
      this.page = 1
      this.getList()
    },

    // 获取列表数据
    getList() {
      this.loading = true
      this.$axios.get(this.$apis.laborManage.selectTeamLaborByPage,
        {
          ...this.searchForm,
          page: this.page,
          size: this.size
        }).then(res => {
          this.total = res.total
          this.tableData = res.list
        }).finally(() => {
          this.loading = false
        })
    },

    // 新增工人
    addWorker() {
      this.$router.push('/laborcontract/add')
    },

    // 删除工人
    deleteConfirm(row) {
      this.$confirm(`是否删除?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.laborManage.deleteTeamLabor,
          {
            teamLaborId	: row.teamLaborId
          }).then(() => {
            this.$message.success('删除成功')
            this.onSearch()
          })
      })
    }
  }

}
</script>

<style scoped lang="scss">
.marLeft {
  margin-left: 0px;
}

.iconfont {
  font-size: 12px;
  margin-right: 8px;
}
</style>
